import React, { FC, useState, useEffect } from 'react';

interface ISearch {
    name: string;
    placeholder: string;
    stateKeys: string[];
    setSearchOptions: (state: any) => void;
    isSearchActive: boolean;
    setIsSearchActive: (state: boolean) => void;
    customStyles?: any;
}

const Search: FC<ISearch> = ({ name, placeholder, stateKeys, setSearchOptions, isSearchActive, setIsSearchActive, customStyles }: ISearch) => {
    const [ inputValue, setInputValue ] = useState<string>('');

    const clearValue = () => {
        setInputValue('');
        setSearchOptions((state: {}) => {
            let resultObject = {};

            stateKeys.forEach(() => {
                resultObject = {};
                setIsSearchActive(false);
            });

            return {
                ...state,
                ...resultObject
            }
        });
    }

    const onChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.value === '') clearValue();
        setInputValue(event.currentTarget.value);
    };

    const onCLickHandler = () => {
        setSearchOptions((state: {}) => {
            let resultObject = {};

            stateKeys.forEach((key: string) => {
                if (inputValue !== '') {
                    // @ts-ignore
                    resultObject[key] = inputValue;
                    setIsSearchActive(true);
                } else {
                    resultObject = {};
                    setIsSearchActive(false);
                }

            });

            return {
                ...state,
                ...resultObject
            }
        });

    };

    const onKeyUpHandler = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key !== 'Enter') return;

        setSearchOptions((state: {}) => {
            let resultObject = {};

            stateKeys.forEach((key: string) => {
                if (inputValue !== '') {
                    // @ts-ignore
                    resultObject[key] = inputValue;
                    setIsSearchActive(true);
                } else {
                    resultObject = {};
                    setIsSearchActive(false);
                }
            });

            return {
                ...state,
                ...resultObject
            }
        });

    };

    useEffect(() => {
        !isSearchActive && setInputValue('');
    }, [isSearchActive]);

    return (
        <div
            className="search"
            style={customStyles ? customStyles : {}}
        >
            <input
                className="search__input"
                type="text"
                name={name}
                placeholder={placeholder}
                value={inputValue ?? ''}
                onChange={onChangeHandler}
                onKeyUp={onKeyUpHandler}
            />
            {inputValue !== ''
                ?
                <p className="search__clear" onClick={clearValue}>x</p>
                :
                <></>
            }

            <div
                className="search__button"
                onClick={onCLickHandler}
            >
                <img
                    className="search__button-icon"
                    src="/images/pages/Resources/Blacklist/icon_search.svg"
                    alt="search"
                />
            </div>
        </div>
    );
};

export default React.memo(Search);
